import React from 'react';
import FindPwContainer from '../components/FindPw/FindPwContainer';

const FindPwPage = () => {
  return <FindPwContainer />;
};

export default FindPwPage;
